/**
 * List of error code
 */
// Avatar upload
export const LIMIT_FILE_SIZE = 'La taille limite est de 2 Mo';
export const BAD_FILE_EXT = "Le format de l'image n'est pas supporté";
